module.exports = {"components.errorMessage.message.default":"Ocurrió un error inesperado.","components.errorMessage.reload.buttonLabel":"recargar","components.errorMessage.message.contentItem1":"Por favor","components.errorMessage.message.contentItem2":"la página"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es/components/ErrorMessage.json
// module id = 757
// module chunks = 0